export const GET_RATE_LIMITS_BY_USER = 'getRateLimitsByUser';
